import React, { useEffect, useState } from 'react';
import Header from '../common/Header'
import Footer from '../common/Footer'
import '../style/products/common.css'

import logo from '../img/quanto_light.webp'

// checkmark circle icon
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CirclePlus } from 'lucide-react';

export default function MobileApp() {
    const [activeTab, setActiveTab] = useState("features");
    const [animateItems, setAnimateItems] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState(0);

    const features = [
        "Accessibility",
        "Kiosk Billing",
        "Real Time Dashboard",
        "Quick Reporting",
        "Stock @ Your Finger Tip",
        "Branch and Stock Transfers",
        "Stock Audit Management",
        "Customer Management",
        "Customer Feedback Management",
        "Customer Walkin Management",
    ];

    const featuresDetails = [
        ["Access anytime, anywhere across the globe on iOS and Android devices.", "We ensure the app is easy to navigate with a clean, user-friendly interface"],
        ["Process sales transactions directly from the mobile app using a Bluetooth or USB-connected printer.", "Apply discounts, promotions, and coupons during checkout", "Send digital invoices and receipts to customers via email, WhatsApp, or SMS."],
        ["Access a dynamic dashboard on the go with hourly sales graph", "Get a comprehensive overview of your business, enabling quick and informed decision-making.", "Access dynamic dashboards with key performance indicators (KPIs) and Business trends."],
        ["Compare daily sales with indicators for high and low sales.", "Analyze stock by Supplier,Product and Store", "View real-time sales data, daily sales comparisons, and performance metrics.", "Analyze stock Ratio, Product turnover, and Supplier performance."],
        ["Easily scan live barcodes to retrieve stock data by attribute across different locations.", "Analyze stock ageing by supplier to manage inventory turnover.", "Monitor inventory levels, track stock movements, and check real-time updates on stock availability."],
        ["Initiate and track stock transfers between different store locations.", "Manage and analyze data from multiple store locations in real-time."],
        ["Perform stock audits and update inventory levels instantly via the mobile app.", "Use barcode scanning to verify stock accuracy and streamline the audit process.", "Receive notifications for any stock mismatches or issues detected during the audit", "Generate and view detailed audit reports and discrepancies directly on the app."],
        ["Access and update customer information, track purchase history, and manage loyalty programs.", "Send promotional messages, order updates, and other notifications to customers"],
        ["Collect Customer feedback through surveys, ratings, and reviews directly in the app.", "Get instant notifications for new feedback submissions.", "Use sentiment analysis and trend identification to gauge customer satisfaction.", "Send automated or personalized responses to address feedback and improve service."],
        ["Maintain a record of customer visits,to better understand customer behavior and its conversion", "Integrate with loyalty programs to track walk-ins and offer rewards or incentives for frequent visits.", "Use data from walk-ins to analyze peak times, customer flow, and store performance.", "Optimize staff scheduling and allocation based on walk-in data to ensure adequate coverage during busy periods."]
    ];

    const benefits = [
        "Increased Operational Efficiency",
        "Improved Customer Satisfaction",
        "Enhanced Decision-Making",
        "Cost Savings",
        "Scalability",
        "Improved Inventory Visibility",
        "Improved Customer Engagement",
        "Effective Sales Promotions"
    ];

    const benefitsDetails = [
        "Streamline workflows and reduce manual tasks, freeing up time for more strategic activities.",
        "Deliver exceptional service with faster transactions, accurate inventory, and personalized experiences.",
        "Utilize advanced analytics to gain insights into performance metrics and market trends, facilitating strategic planning.",
        "Optimize inventory management and reduce overhead costs through efficient operations and accurate forecasting.",
        "Grow your retail business with a flexible ERP solution that adapts to your changing needs.",
        "Gain full transparency into stock levels, ensuring optimal inventory availability and preventing overstocking or shortages.",
        "CRM tools help track interactions, personalize experiences, and boost customer retention, driving stronger relationships and repeat business.",
        "Easily create, manage, and track sales promotion schemes to attract customers, boost sales, and enhance brand loyalty."
    ];

    useEffect(() => {
        setAnimateItems(true);
        setSelectedPoint(0);
        const timer = setTimeout(() => setAnimateItems(false), 2200);
        return () => clearTimeout(timer);
    }, [activeTab]);

    const items = activeTab === "features" ? features : benefits;
    const details = activeTab === "features" ? featuresDetails : benefitsDetails;

    const handlePointClick = (index) => {
        setSelectedPoint(index);
    };

    // useEffect(() => {
    //     const button = document.querySelector('button');
    //     button.addEventListener('mouseover', () => {
    //         button.style.backgroundColor = '#b96d00';
    //         button.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
    //         button.style.transform = 'translateY(-2px)';
    //     });
    //     button.addEventListener('mouseout', () => {
    //         button.style.backgroundColor = 'transparent';
    //         button.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
    //         button.style.transform = 'translateY(0)';
    //     });
    // }, []);

    return (
        <>
            <Header />
            <section className="about-title-section">
                <h2><img alt="quantologo" src={logo} style={{ width: 280, marginLeft: 10, verticalAlign: "middle", marginBottom: 20 }} />Mobile App</h2>
            </section>
            <div style={styles.container} className='products-container'>
                <header style={styles.header}>
                    <h1 style={styles.titleInfo} className='products-section-title'>Quanto Mobile App : Empowering Store Management Anytime, Anywhere on Real Time Basis</h1>
                </header>
                <button style={{ ...styles.tabButton, margin: '5px auto' }} className='download-btn-products'>Download Brochure</button>
                <style>
                    {`
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(20px); scale(0.75) }
                        100% { opacity: 1; transform: translateY(0); scale(1.25) }
                    }
                    @keyframes grow2 {
                        0% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.2); opacity: 0.6; color: black }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    @keyframes pulseGlow {
                        0% {
                        transform: scale(1);
                        opacity: 1;
                        color: #ff8c00;
                        text-shadow: 0 0 10px rgba(255, 140, 0, 0.5);
                        }
                        50% {
                        transform: scale(1.1);
                        opacity: 0.8;
                        color: #ffc107;
                        text-shadow: 0 0 20px rgba(255, 193, 7, 0.7);
                        }
                        100% {
                        transform: scale(1);
                        opacity: 1;
                        color: #ff8c00;
                        text-shadow: 0 0 10px rgba(255, 140, 0, 0.5);
                        }
                    }
                    `}
                </style>
                <button
                    className='tab-btn-1'
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "features" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => setActiveTab("features")}
                >
                    Key Features
                    <span style={styles.tabIcon}>
                        {activeTab === "features" ? "🟡" : "⚪"}
                    </span>
                </button>
                <div style={{ display: 'flex', width: "80%", alignSelf: 'center' }} className='points-container'>
                    <div style={styles.rightSection} className='products-right-section'>
                        <div style={styles.itemsContainer} className='products-right-inside-section'>
                            {items.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        ...styles.item,
                                        opacity: animateItems ? 0 : 1,
                                        animation: animateItems
                                            ? `fadeIn 0.5s ease-out ${index * 0.2}s forwards`
                                            : "none",
                                    }}
                                    className='check-points'
                                    onClick={() => handlePointClick(index)}
                                >
                                    {/* <span style={styles.itemIcon}>⦿</span> */}
                                    <CheckCircleOutlineIcon style={styles.itemIcon} />
                                    <span style={styles.itemText} className='products-item-text'>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    {selectedPoint !== null && (
                        <div style={styles.detailsSection} className='products-details-section'>
                            <h2 style={styles.detailsTitle} className='products-details-title'>{items[selectedPoint]}</h2>
                            {/* <p style={styles.detailsText}>{details[selectedPoint]}</p> */}
                            {details[selectedPoint].map((detail, index) => (
                                <p key={index} style={styles.detailsText} className='products-details-description'>
                                    {/* point */}
                                    <CirclePlus size={22} style={{
                                        color: '#ff8c00',
                                        marginRight: 10,
                                        alignSelf: 'center',
                                        marginTop: 10,
                                        position: 'relative',
                                        top: 4,
                                    }} />
                                    {detail}
                                </p>
                            ))}
                        </div>
                    )}
                </div>
            </div >
            <Footer />
        </>
    );
}

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #000000 0%, #434343 100%)",
        color: "#fff",
        padding: "40px",
        borderRadius: "20px",
        position: "relative",
        overflow: "hidden",
        minHeight: "60vh",
        width: "95vw",
        margin: "20px auto",
    },
    leftSection: {
        flex: "1",
        paddingRight: "50px",
        marginBottom: "30px",
        // width: "100%"
    },
    rightSection: {
        // flex: "2",
        // position: "relative",
        width: "70vw",
        // alignSelf: "center",
        marginRight: '20px'

    },
    title: {
        fontSize: "3em",
        textAlign: "center",
        marginBottom: "20px",
    },
    tabContainer: {
        display: "flex",
        justifyContent: "center",
        gap: "20px",
    },
    tabButton: {
        backgroundColor: "transparent",
        border: "2px solid #ff8c00",
        color: "#fff",
        fontWeight: 700,
        padding: "15px 30px",
        borderRadius: "35px",
        fontSize: "1.5em",
        cursor: "pointer",
        transition: "all 0.3s ease",
        display: "flex",

        alignItems: "center",
        justifyContent: "center",
        display: 'block',
        margin: '20px auto'
    },
    activeTabButton: {
        backgroundColor: "#f39d3c",
        color: "#000",
    },
    tabIcon: {
        marginLeft: "10px",
        animation: "pulseGlow 4.5s ease-in-out 0.5s infinite",
    },
    itemsContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridTemplateRows: "repeat(4, 1fr)",
        gap: "20px",
        backgroundColor: "rgba(255, 140, 0, 0.8)",
        borderRadius: "20px",
        padding: "30px",
    },
    item: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        cursor: "pointer",
        padding: "10px",
        borderRadius: "10px",
        transition: "background-color 0.3s ease",
    },
    itemIcon: {
        marginRight: "10px",
        fontSize: "30px",
        animation: "grow2 4.5s ease-in-out 0.5s infinite",
    },
    itemText: {
        fontSize: "1.5em",
        fontWeight: 600,
    },
    detailsSection: {
        // marginTop: "30px",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        borderRadius: "20px",
        padding: "30px",
        animation: "fadeIn 0.5s ease-out",
        width: "50vw",
        // alignSelf: "center",
        boxSizing: "border-box",
    },
    detailsTitle: {
        fontSize: "2em",
        margin: 0,
        marginBottom: "15px",
        color: "#ff8c00",
        textAlign: 'center'
    },
    detailsText: {
        fontSize: "1.25em",
        lineHeight: "1.6",
        margin: 0,
    },

    header: {
        alignItems: 'center',
    },
    titleInfo: {
        fontSize: '2.3em',
        fontWeight: 700,
        color: '#fff',
        textAlign: "center",
        marginBottom: 30
    },
    button: {
        backgroundColor: '#f6a608',
        color: 'white',
        padding: '12px 24px',
        border: 'none',
        width: "300px",
        borderRadius: '30px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        letterSpacing: '1px',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        outline: 'none',
        margin: '20px auto',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    section: {
        margin: '30px 0',
        width: "70vw",
        alignSelf: "center",
    },
    sectionTitle: {
        fontSize: '2em',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '20px',
    },
    paragraph: {
        fontSize: '1.35em',
        lineHeight: '1.6',
        color: '#ccc',
    },
};

